/** cookies **/
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
   function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function eraseCookie(key) {
        var keyValue = getCookie(key);
        setCookie(key, keyValue, '-1');
    }
/** cookies end**/
$(document).ready(function(){ 
var x=0;
    var no_of_items = $('.custom-radios').attr('numb-of-items');
	$('body').on('click', '.custom-radios', function()	 { 
      
    var data_id = $(this).attr('data-attr');
    var data_v_title = $(this).attr('data-variant-title');
    var data_v_price = $(this).attr('data-price');
    var data_v_img = $(this).attr('data_img');
    var data_p_title = $(this).attr('data_product_title');
    var data_p_id = $(this).attr('data-pid');
    var drawer_prdct = $(this).parents("li.grid__item.bundle_template").find(".card-wrapper .main-container-div-jtpl").html();
    $(this).toggleClass("main-clicked");
    var check_length =  $(".custom-radios.main-clicked").length;
  
      if ($(this).hasClass("main-clicked")){
      $(".cstm-append-cls").append(drawer_prdct);
      if($('.cstm-append-cls .all-info-container').length < 1){
      $('span.custom-add-to-cart.product-variant-submit-button').hide();
      }else{
       $('span.custom-add-to-cart.product-variant-submit-button').show();
     }
      if($('.cstm-append-cls .all-info-container').length  >= no_of_items){
      $('.bundle-drawer-btn').show();
      }else{
      $('.bundle-drawer-btn').hide();
      }
      var productData=[];
      var getBundledata= getCookie('bundle-selected-product');
     if (getBundledata.length > 0){
      getBundledata = getBundledata.split(',');
      $(getBundledata).each(function(index,value){
      productData.push(value);
     });
   }if(productData.length >0){
      if(productData.indexOf(data_id) < 0 ){
      productData.push(data_id+'#'+data_v_title+'#'+data_v_price+'#'+data_p_title+'#'+data_v_img+'#'+data_p_id);
     }
   }
    else{
      productData.push(data_id+'#'+data_v_title+'#'+data_v_price+'#'+data_p_title+'#'+data_v_img+'#'+data_p_id);
   }
      setCookie('bundle-selected-product', productData, 1);
      $(this).parents('.bundle_template').find(".checked").css({ "display": "block" , "background": "#000"});
      $(this).parents('.bundle_template').find(".choose-to-add-bundle").css("display", "none"); 
    }
      else{
        $('.all-info-container.cart-product[var-id="'+data_id+'"]').find('.remove-prdct').trigger('click');
        if($('.cstm-append-cls .all-info-container').length < 1){
        $('span.custom-add-to-cart.product-variant-submit-button').hide();
      }else{
        $('span.custom-add-to-cart.product-variant-submit-button').show();
     }
          $(this).parents('.bundle_template').find(".choose-to-add-bundle").css("display", "block"); 
          $(this).parents('.bundle_template').find(".checked").css({ "display": "none" , "background": "#000"});
      }
	});

    $(document).on('click', '.bundle-drawer-close-btn , .bundle-drawer-btn', function(){   
     var drawer_prdct = $(this).parents(".cc-product-block").find(".main-container-div-jtpl").html();
     if($(this).hasClass('bundle-drawer-btn')){
        $(this).hide();
     
     }
      if($(this).hasClass('modal-close')){
      if($('.cstm-append-cls .all-info-container').length  >= no_of_items){
        $('.bundle-drawer-btn').show();
        }else{
        $('.bundle-drawer-btn').hide();
        }
      }
        $('.bundle-drawer-right').toggleClass('bundle-drawer-open');
        if($('.cstm-append-cls .all-info-container').length < 1){
        $('span.custom-add-to-cart.product-variant-submit-button').hide();
     }else{
        $('span.custom-add-to-cart.product-variant-submit-button').show();
     }
      $("body").toggleClass("collection-bndle-open");
  });
  
    $(document).on('click', '.remove-prdct', function(){ 
    var v_id = $(this).parents(".all-info-container").attr('var-id');
    var p_id = $(this).parents(".all-info-container").attr('pd_id');        
    $(this).parents(".cstm-append-cls .all-info-container").remove();
       
    $('.custom-radios[data-attr="'+v_id+'"]').removeClass('main-clicked');
    $('.custom-radios[data-attr="'+v_id+'"]').find('.choose-to-add-bundle').css("display", "block");
    $('.custom-radios[data-attr="'+v_id+'"]').find('.checked').css({ "display": "none" , "background": "#000"});
            
    if($('.cstm-append-cls .all-info-container').length < 1){
    $('span.custom-add-to-cart.product-variant-submit-button').hide();
    }
    if($('.cstm-append-cls .all-info-container').length  >= no_of_items){
    $('.bundle-bundle-btn.bundle_btn_active').show();
    }else{
    $(".modal-close.bundle-drawer-close-btn").trigger('click');
    }
   
    var new_bndl_val=[];
    var getBundledata= getCookie('bundle-selected-product');
    getBundledata = getBundledata.split(',');
    $(getBundledata).each(function(index,value){
    var variant_data = value.split('#');
    if(variant_data[0] != v_id){
    new_bndl_val.push(value);
    }
  });
   setCookie('bundle-selected-product', new_bndl_val, 1);
 });

 /* get bundle product cookies */
    var productData=[];
    var getBundledata= getCookie('bundle-selected-product');
     if($('.cstm-append-cls .all-info-container').length <1){
      $('span.custom-add-to-cart.product-variant-submit-button').hide();
     }else{
       $('span.custom-add-to-cart.product-variant-submit-button').show();
     }
   if(getBundledata != undefined && getBundledata.length >0){
     getBundledata = getBundledata.split(',');
     $(getBundledata).each(function(index,value){
   var variant_data = value.split('#');
        console.log(variant_data);
   var bundle_pd = $(`<div class="all-info-container cart-product" var-id="${variant_data[0]}" pd_id=""><div class="product-media-jtpl cart-product__image"><img class="variantsel-img-bundle-jtpl" width='100' height='100' src="${variant_data[4]}"> </div><div class="product-details-info-jtpl cart-product__content"><p class="cart-product__content__title product-title">${variant_data[3]}</p><p class="cart-product__content__price"> <span class="prdct-price">${variant_data[2]}</span></p><span class="cart-product__content__meta prdct-variant">${variant_data[1]}</span></div><input class="variantsel-bundle-jtpl" name="id" value="${variant_data[0]}" type="hidden"><div class="cstm-remove-andqntty-jtpl">
                   <div class="cstm-quantity-wrapper-jtpl">
                   <a class="cstm-minus" id="ae-formFieldLabelOptIn_5k8gv4i1s47_14"><span>−</span></a>
                <input class="variantsel-bundle-jtpl-qntty"   min="1" name="quntity" value="1" type="number" aria-labelledby="ae-formFieldLabelOptIn_5k8gv4i1s47_14"/>
                   <a class="cstm-plus"><span>+</span></a>
                   </div>
                   <span class="remove-prdct">Remove</span>
                   </div>
           </div>`);
    $('.inner.bundle-drawer.bundle-drawer-right span.cstm-append-cls').append(bundle_pd);
    $('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('li.grid__item.bundle_template').find('.product-variant-select option[value="'+variant_data[0]+'"]').attr('selected','selected');
    
    $('.custom-radios[data-pid="'+variant_data[5]+'"]').attr({'data-attr':variant_data[0],'data_img':variant_data[4],'data-price':variant_data[2],'data-variant-title':variant_data[1]});
    $('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container').attr('var-id',variant_data[0]); 
    $('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container img.variantsel-img-bundle-jtpl').attr('src',variant_data[4]); 
    $('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container .product-details-info-jtpl .prdct-variant').html(variant_data[1]); 
    $('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container .product-details-info-jtpl .variantsel-bundle-jtpl').attr('value',variant_data[0]);       
    $('.custom-radios[data-attr="'+variant_data[0]+'"]').addClass('main-clicked');
    $('.custom-radios[data-attr="'+variant_data[0]+'"]').find(".checked").css({ "display": "block" , "background": "#000"});
    $('.custom-radios[data-attr="'+variant_data[0]+'"]').find(".choose-to-add-bundle").css("display", "none"); 
      });
 
 

   }
   setTimeout(function(){
     $('.product-variant-select').trigger("change");
    if($('.inner.bundle-drawer.bundle-drawer-right .cstm-append-cls .all-info-container').length  >= no_of_items){
    $('.bundle-drawer-btn').show();
    }else{
    $('.bundle-drawer-btn').hide();
    }
  });
  $('body').on('change', '.product-variant-select', function(){
    var editid_bundle = $(this).val();
    var vr_img = $(this).find('option:selected').attr('data-src-img');
    var data_src = $(this).find('option:selected').attr('data-src');
    
    var vr_price = $(this).find('option:selected').attr('data-vprice');
    var vr_title = $(this).find('option:selected').attr('variant-data');
    $(this).parents('li.grid__item.bundle_template').find('.custom-radios').attr('data_img',vr_img);
    $(this).parents('li.grid__item.bundle_template').find('.custom-radios').attr('data-price',vr_price);
    $(this).parents('li.grid__item.bundle_template').find('.custom-radios').attr('data-variant-title',vr_title);
    $(this).parents('li.grid__item.bundle_template').find('.main-container-div-jtpl .all-info-container').attr('var-id',editid_bundle);
    $(this).parents('li.grid__item.bundle_template').find('.main-container-div-jtpl .variantsel-img-bundle-jtpl').attr('src',vr_img);
    $(this).parents('li.grid__item.bundle_template').find('.main-container-div-jtpl .prdct-price').text(vr_price);
    $(this).parents('li.grid__item.bundle_template').find('.main-container-div-jtpl .prdct-variant').text(vr_title);
    $(this).parents('li.grid__item.bundle_template').find('.main-container-div-jtpl .variantsel-bundle-jtpl').val(editid_bundle);
    $(this).parents('li.grid__item.bundle_template').find('.card--image-animate img').attr('srcset',data_src);
     
    var variant_id = $(this).parents('li.grid__item.bundle_template').find('.custom-radios').attr('data-attr',editid_bundle);
    var check_length = $('.cstm-append-cls .all-info-container .variantsel-bundle-jtpl[value="'+editid_bundle+'"]').length;
    if (check_length > 0){
     $(this).parents('li.grid__item.bundle_template').find('.custom-radios').addClass('main-clicked');
     $(this).parents('li.grid__item.bundle_template').find(".checked").css({ "display": "block" , "background": "#000"});
     $(this).parents('li.grid__item.bundle_template').find(".choose-to-add-bundle").css("display", "none"); 
    }else{
     $(this).parents('li.grid__item.bundle_template').find('.custom-radios').removeClass('main-clicked');
     $(this).parents('li.grid__item.bundle_template').find(".checked").css({ "display": "none" , "background": "#000"});
     $(this).parents('li.grid__item.bundle_template').find(".choose-to-add-bundle").css("display", "block"); 
    }
  });
   /* Get bundle product cookies end*/
  
    $(document).on('click', '.cstm-minus', function(){
    var prdct_quntity = $(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
    prdct_quntity--;
    $(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").attr("value", prdct_quntity);
     
    if(prdct_quntity < 1){
    $(this).parents(".all-info-container").find(".remove-prdct").trigger('click');
    }
    var qnty =0;
    $('.inner.cart-drawer .all-info-container .cstm-remove-andqntty-jtpl .variantsel-bundle-jtpl-qntty').each(function () {
    qnty= qnty + parseInt(this.value);
    });
    if(qnty < 2){
    $(".cart-drawer-close-btn").trigger('click');
    }
   });
    $(document).on('click', '.cstm-plus', function(){
    var prdct_quntity = $(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
    var variant_id = $(this).parents(".all-info-container").find('.variantsel-bundle-jtpl').attr('value');
    prdct_quntity++;
    $(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").attr("value", prdct_quntity);
 });

     $(document).on('click', '.custom-add-to-cart', function(){  

         var items = new Array();
         var discount_code = $(".cartform .cart_bundle_disc").val();
         $('.cstm-append-cls .variantsel-bundle-jtpl').each(function() {
          var upsell= {};
          var pro_variant_id = $(this).val();
          var prdct_quntity = $(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
          var properties = {};
          properties["_bundle"] = "bundle";
          if($("body").hasClass("page-pick-3-amp-save-50")){
          properties["_pick_bundle"] = "pick-3-save-50";
          }
          upsell['id'] = pro_variant_id;
          upsell['quantity'] = prdct_quntity;
          upsell['discount'] = discount_code;
          upsell['properties'] = properties;
          //console.log(upsell);
          items.push(upsell);
        });
            setTimeout(function () {
            //console.log(items);
            var content = addToCart(items);             
         }, 500); 

    });
    function addToCart(items)
     {
      jQuery.ajax({
        type: 'POST',
         url: "/cart/add.js",
        data: {items:items},
        dataType: 'json',
       success: function(data) {               
       // window.location.href = '/cart'; 
        $('.cart-drawer-container summary').trigger('click');
        $('.bundle-drawer-right').removeClass('bundle-drawer-open');
        $('body').removeClass('collection-bndle-open');
        $('.custom-radios').removeClass('main-clicked');
        $('.custom-radios').find('.choose-to-add-bundle').css("display", "block");
        $('.custom-radios').find('.checked').css({ "display": "none" , "background": "#000"});
        $('.cstm-append-cls').html('');
        $('.product-variant-select option').eq(0).attr('selected','selected');
        eraseCookie('bundle-selected-product');
        updateCart();
       
        },
        error: function (xhr, ajaxOptions, thrownError) {
			console.log("error");
			console.log(xhr.status);
			console.log(thrownError);
		}
      });
    }
});